import {
  AfterContentInit,
  Component,
  ElementRef,
  EventEmitter, HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {SharedService} from "../../../../../../../core/services/store/shared-store/shared-storage.service";
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import {CollectionItem} from "../../../../../../analytics-settings/services/collection.model";
import {CollectionService} from "../../../../../../analytics-settings/services/collection.service";
import find from 'lodash/find';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CMSService } from '../../../../../../../shared/components/cms/service/cms.service';
import { RemoveCollectionComponent } from '../../../../analytics-setting/remove-collection/remove-collection.component';
import { swalMini } from '../../../../../../../shared/utils/utils';
import {ActiveFormService} from "../../../../../services/active-form.service";
import {
  AddCollectionsComponent
} from "../../../../../../analytics-settings/components/add-collections/add-collections.component";
import {Router} from "@angular/router";
import { NgClass, AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatSelect, MatOption } from '@angular/material/select';
@Component({
    selector: 'app-analytics-settings',
    templateUrl: './analytics-settings.component.html',
    styleUrls: ['./analytics-settings.component.scss'],
    imports: [ReactiveFormsModule, NgClass, MatButton, MatTooltip, MatSelect, MatOption, AsyncPipe]
})
export class AnalyticsSettingsComponent implements OnInit{
  public isLeftVisible: boolean;
  public showAnalyticsSettingsForm: boolean;
  isSaveEnabled: boolean;
  collectionItems: CollectionItem[];
  assets: CollectionItem[] = [];
  collectionCardsList: any[] = [];
  exitingFeatures: any[] = [];
  isShowAddCollectionList: boolean;
  isShowNoSearchResult: boolean;
  isSearchValue: boolean;
  mySubscription: Subscription;
  removeCollectionSub: Subscription;
  singleDataSub: Subscription;
  startAndEndSub: Subscription;
  multiDataSub: Subscription;
  singleDataText: string = '';
  singleData;
  startAndEndData;
  multiData;
  selectedLevel = {
    '0': true,
    '99': false,
    selectedKey: '0'
  };
  reportLevels = [
    {
      name: 'Report Start',
      value: 0
    },
    {
      name: 'Report Level 1',
      value: 1
    },
    {
      name: 'Report Level 2',
      value: 2
    },
    {
      name: 'Report Level 3',
      value: 3
    },
    {
      name: 'Report Level 4',
      value: 4
    },
    {
      name: 'Report Level 5',
      value: 5
    },
    {
      name: 'Report Level 6',
      value: 6
    },
    {
      name: 'Report Level 7',
      value: 7
    },
    {
      name: 'Report Level 8',
      value: 8
    },
    {
      name: 'Report Level 9',
      value: 9
    },
    {
      name: 'Report Level 10',
      value: 10
    },
    {
      name: 'Report End',
      value: 99
    }
  ];

  @ViewChild('analyticsSlider') analyticsSlider: ElementRef;
  @Input() stepAnalyticsSettings;
  @Input() isDisabled: boolean = this.sharedService.getEnvironment() === 'prod';
  @Output() updateSettings = new EventEmitter();
  @Output() close = new EventEmitter();

  constructor(
      public sharedService: SharedService,
      private fb: UntypedFormBuilder,
      private collectionService: CollectionService,
      private cmsService: CMSService,
      private dialog: MatDialog,
      private activeFormService: ActiveFormService,
      private router: Router
      ) {
  }

  settingsFormGroup:  UntypedFormGroup = new UntypedFormGroup({});
  errorText: Boolean = false;

  ngOnInit() {
    this.initForm();
    this.collectionCardsList = [];
    this.reloadAddtoCollectionDropdown();
    this.removeCollectionSub = this.collectionService.removeCollection.subscribe((card) => {
        this.cardCollections.removeAt(card.index);
        this.collectionCardsList = this.collectionCardsList.filter(item => item.id !== card.id);
        this.updateCollectionCardList();
    });
   
    this.singleDataSub = this.cmsService.cmsCall('5a5IJapkmT2u7fwhbljdt0', 'entry').subscribe(cmsData =>{
      this.singleData = cmsData?.['text']?.['content']?.[0]?.['content']?.[0]?.value;
    });
    this.startAndEndSub = this.cmsService.cmsCall('6Q4FAwCCQ0wP2bOLG839F0', 'entry').subscribe(cmsData =>{
      this.startAndEndData = cmsData?.['text']?.['content']?.[0]?.['content']?.[0]?.value;
    });
    this.multiDataSub = this.cmsService.cmsCall('1RbLKUxGZh54wX622GthXL', 'entry').subscribe(cmsData=>{
      this.multiData = cmsData?.['text']?.['content']?.[0]?.['content']?.[0]?.value;
    });
    this.collectionService.collectionAdded.subscribe(data => {
      this.addCllection(data);
      this.reloadAddtoCollectionDropdown();
    });
  }

  reloadAddtoCollectionDropdown() {
    this.mySubscription = this.collectionService.getCollections().subscribe((response) => {
      let collections = response as CollectionItem[];

      collections =  collections.filter(collection => !collection.disabled);

      if(this.stepAnalyticsSettings) {
        this.setFormValue(collections);
      }

      this.collectionItems = collections;
      this.updateCollectionCardList();

      this.assets = this.collectionItems;
    });
  }

  changeControlEvent() {
    this.activeFormService.setActiveForm(this.settingsFormGroup);
  }

  initForm(){
    this.settingsFormGroup = this.fb.group({
      nodeReportLabel: new UntypedFormControl({value: '', disabled: this.isDisabled}, []),
      searchValue: new UntypedFormControl('', []),
      cardCollections : this.fb.array([]),
    });
  }

  get cardCollections() {
    return this.settingsFormGroup.controls["cardCollections"] as UntypedFormArray;
  }

  setFormValue(collections: any) {
    if(this.stepAnalyticsSettings.reportingLabels) {
      this.settingsFormGroup.controls.nodeReportLabel.setValue(this.stepAnalyticsSettings.reportingLabels);
    }
    
    if(this.stepAnalyticsSettings.reportingFeatures) {
      const reportingFeatures = this.stepAnalyticsSettings.reportingFeatures;
      Object.keys(reportingFeatures).forEach(key => {
        const collection = find(collections, { featureUUID: key });
        if(collection) {
          this.collectionCardsList.push({
            type: collection.featureType,
            name: collection.featureName,
            id: collection.featureUUID,
            stepTitle: "step1"
          });
          
          if(collection.featureType === 'FULL') {
            this.cardCollections.push(this.fb.group({
              level: new UntypedFormControl(reportingFeatures[key].level, [Validators.required]),
              id: new UntypedFormControl(collection.featureUUID)
            }));
          } else {
            this.cardCollections.push(this.fb.group({
              level: new UntypedFormControl(`${reportingFeatures[key].level}`, []),
              id: new UntypedFormControl(collection.featureUUID)
            }));
          }
        }
      });
    }
    this.activeFormService.setActiveForm(this.settingsFormGroup);
  }

  showAddToCollection() {
    this.hideDropdown();
    this.isShowAddCollectionList = !this.isShowAddCollectionList;
  }


  clearSearch(){
    this.settingsFormGroup.controls.searchValue.setValue('');
    this.collectionItems = this.assets;
    this.isShowNoSearchResult = false;
    this.isSearchValue = false;

  };

  searchCollection() {
    this.collectionItems = this.assets;
    this.isShowNoSearchResult = false;
    const searchValue = this.settingsFormGroup.get('searchValue').value 
    this.isSearchValue = false;
    if(searchValue !== '') {
      this.isSearchValue = true;
      this.collectionItems = this.collectionItems.filter(collection => collection.featureName.toLowerCase().includes(searchValue.toLowerCase()));
      this.isShowNoSearchResult = this.collectionItems.length === 0 ? true : false; 
    }
  }

  addCllection(collection: any) {
    this.isSaveEnabled = true;
    if(collection.featureType === 'FULL') {
      this.cardCollections.push(this.fb.group({
        level: new UntypedFormControl('', [Validators.required]),
        id: new UntypedFormControl(collection.featureUUID)
      }));
    } else {
      this.cardCollections.push(this.fb.group({
        level: new UntypedFormControl('0'),
        id: new UntypedFormControl(collection.featureUUID)
      }));
    }

    this.collectionCardsList.push({
      "type": collection.featureType,
      "name": collection.featureName,
      "id": collection.featureUUID,
      "stepTitle": "step1"
    });
    this.isShowAddCollectionList = false;
    this.updateCollectionCardList();
    this.activeFormService.setActiveForm(this.settingsFormGroup);
  }

  updateCollectionCardList() {
    this.collectionItems = this.collectionItems.map(
      (item) => {
        if(find(this.collectionCardsList, { id: item.featureUUID})) {
          return {
            ...item,
            inUse: true
          }
        } else {
          return {
            ...item,
            inUse: false
          }
        }   
      }
    )
  }

  removeCollection(cardData: any, i) {
    this.isSaveEnabled = true;
    cardData = {
      ...cardData,
      index: i
    }
    const dialogRef = this.dialog.open(RemoveCollectionComponent, {
      data: cardData
    });
    this.activeFormService.setActiveForm(this.settingsFormGroup);
  }

  saveSettings() {
    const settingsFormData = this.settingsFormGroup.getRawValue();
    const featuresObj = this.convertArrayToObject(settingsFormData.cardCollections);

    if (settingsFormData.cardCollections.length === 0) {
      this.updateSettings.emit({
        reportingFeatures: [],
        reportingLabels: settingsFormData.nodeReportLabel
      });
      this.settingsFormGroup.controls.nodeReportLabel.setErrors(null);
      return;
    } else {
      // Check if the nodeReportLabel is empty or not provided
      const isNodeReportLabelEmpty = !settingsFormData.nodeReportLabel || settingsFormData.nodeReportLabel.trim() === '';

      // If the nodeReportLabel is empty, mark the control as invalid
      if (isNodeReportLabelEmpty) {
        this.settingsFormGroup.controls.nodeReportLabel.setErrors({required: true});
      }
    }
    if (this.settingsFormGroup.status === 'INVALID') {
      this.settingsFormGroup.markAllAsTouched();
      swalMini({
        title: 'Validation failed, please check for errors!',
        type: 'error',
      });
      return false;
    }
    const data = {
        reportingFeatures: featuresObj,
        reportingLabels: settingsFormData.nodeReportLabel
      };
      this.updateSettings.emit(data);
  }

  convertArrayToObject (array) {
    const initialValue = {};
    return array.reduce((obj, item) => {
      return {
        ...obj,
        [item['id']]: {
          level: parseInt(item['level'])
        },
      };
    }, initialValue);
  }

  hideDropdown() {
    document.getElementById('dropdownMenu').classList.remove('show');
    this.isShowAddCollectionList = false;
  }

  closeAnalyticsOverlay(){
    this.hideDropdown();
    this.close.emit();
  };

  ngOnDestroy(): void {
    this.activeFormService.clearActiveForm();
    this.mySubscription?.unsubscribe();
    this.removeCollectionSub?.unsubscribe();
    this.singleDataSub?.unsubscribe();
    this.startAndEndSub?.unsubscribe();
    this.multiDataSub?.unsubscribe();
  }

  analyticsDropdown() {
    document.getElementById('dropdownMenu').classList.toggle('show');
  }

  openPopup() {
    this.dialog.open(AddCollectionsComponent, { data: {'callFromNode': true} });
    document.getElementById('dropdownMenu').classList.remove('show');
  }

  redirectAnalyticsSettings() {
    this.activeFormService.setActiveForm(this.settingsFormGroup);
    this.settingsFormGroup.markAllAsTouched();
    this.settingsFormGroup.markAsDirty();
    const element = document.getElementById('leftSideBarAnalyticsSettings') as HTMLElement;
    element.click();
    document.getElementById('dropdownMenu').classList.remove('show');
  }

}
